// M9 contract #4 (lead wiring): player commands that emit no event of their own but can make a building
// stall report the buildings they touched through `audio.noteAction(bid)` — the stall bonk is per building
// and needs a recent player action on it (eventMap.ts "player-caused").
//   pause / setTarget          → the building itself
//   paintChutes / eraseChutes  → every building on or orthogonally next to a painted / erased cell (the
//                                machine whose output a new chute blocks or an erased chute cut off)
// Pure: reads the state after the command applied; null for every other command.
import type { CmdResult, Command } from '../sim/commands.ts';
import type { SimState } from '../sim/state.ts';

type Pt = { x: number; y: number };

function touching(s: SimState, cells: readonly Pt[]): number[] {
  const out: number[] = [];
  for (const b of s.buildings) {
    if (cells.some((c) => Math.abs(b.x - c.x) + Math.abs(b.y - c.y) <= 1)) out.push(b.id);
  }
  return out;
}

/** Buildings a successful quiet command acted on (`noteAction` each), or null (not such a command). */
export function actionBids(cmd: Command, r: CmdResult, s: SimState): number[] | null {
  if (!r.ok) return null;
  switch (cmd.c) {
    case 'pause':
    case 'setTarget':
      return [cmd.bid];
    case 'paintChutes':
      return touching(s, cmd.path);
    case 'eraseChutes':
      return touching(s, cmd.cells);
    default:
      return null;
  }
}
